import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Signup from './pages/SignUp';
import Login from './pages/Login';
import Home from './pages/Home';
import Upload from './components/Upload';
import Chat from './components/Chat';
 // Import the new Home component

function App() {
  return (
    <>
      <Router>
        <Navbar />

        <Routes>
          <Route path="/" element={<Home/>} /> {/* Home page route */}
          <Route path="/signup" element={<Signup />} /> {/* Signup page */}
          <Route path="/login" element={<Login />} /> {/* Login page */}
          <Route path="/upload" element={<Upload/>} /> {/* Upload route */}
          <Route path="chat" element={<Chat/>}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
